import React from 'react';

import { Button } from '@/components/ui/Button';
import { Card } from '@/components/ui/Card';

export class ErrorBoundary extends React.Component<React.PropsWithChildren, { hasError: boolean }> {
  constructor(props: React.PropsWithChildren) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="mx-auto flex min-h-screen max-w-3xl items-center justify-center p-6">
          <Card className="p-8">
            <h1 className="text-2xl font-semibold">Что-то пошло не так</h1>
            <p className="mt-3 text-sm text-slate-600 dark:text-slate-300">
              Приложение упало в рантайме. Обнови страницу и попробуй ещё раз.
            </p>
            <Button className="mt-6" onClick={() => window.location.reload()}>
              Перезагрузить
            </Button>
          </Card>
        </div>
      );
    }

    return this.props.children;
  }
}
